import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.empty');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-layout-empty',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.empty/view.scss */
:host {
  display: block;
  min-height: 100%;
  background: radial-gradient(circle at 15% 10%, rgba(0, 106, 166, 0.1), transparent 34rem), linear-gradient(145deg, #eef4f7 0%, #f8fafb 48%, #edf3f5 100%);
}`],
})
export class LayoutEmptyComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
    }
}

export default LayoutEmptyComponent;